import { render, staticRenderFns } from "./ShareCodeContent.vue?vue&type=template&id=27da7dfc&scoped=true"
import script from "./ShareCodeContent.vue?vue&type=script&lang=js"
export * from "./ShareCodeContent.vue?vue&type=script&lang=js"
import style0 from "./ShareCodeContent.vue?vue&type=style&index=0&id=27da7dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27da7dfc",
  null
  
)

export default component.exports